import React from 'react'
import Translation from './Translation'
import getTranslationTime from '../functions/getTranslationTime'

const HintText = ({
   purchaseblePerformances,
   fullyfilteredPerformance,
   translation,
   itemData,
   movieTimesVersion
}) => {
   const {limitations, startingDate} = itemData
   const {visibleFrom, showCountdown} = limitations
   const formatedDate =  visibleFrom ? getTranslationTime('performanceDates', translation, visibleFrom) : startingDate ? getTranslationTime('performanceDates', translation, startingDate) : null
   const hintText = (purchaseblePerformances[0] && fullyfilteredPerformance[0]) ? <Translation id="selectTime" trans={translation}>Uhrzeit auswählen</Translation> : ((formatedDate || visibleFrom) && !purchaseblePerformances[0]) ? ((showCountdown && visibleFrom) || (!showCountdown)) ? <span><Translation id="availableFrom" trans={translation}>Verfügbar ab</Translation> {formatedDate}</span> : '' : ''
   const hintTextMovietimes = (purchaseblePerformances[0] && fullyfilteredPerformance[0]) ? <Translation id="selectTime" trans={translation}>Uhrzeit auswählen</Translation> : ((formatedDate || visibleFrom) && !purchaseblePerformances[0]) ? ((showCountdown && visibleFrom) || (!showCountdown)) ? <span><Translation id="availableFrom" trans={translation}>Verfügbar ab</Translation> {formatedDate}</span> : '' : <span><Translation id="noPerformances" trans={translation}>Keine Spielzeiten verfügbar.</Translation></span>

   return (
      movieTimesVersion ? hintTextMovietimes ? <p className= "buy-ticket-hint text-large-bold">{hintTextMovietimes}</p> : '' : hintText && <p className="showtimes-title typo-color-muted title-large">{hintText}</p>
   )
}

export default HintText